import Navbar from './Navbar';
import './App.css';
import Home from './Home';
import {BrowserRouter as Router,Routes,Route} from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import Cart from './Cart'
import Login from './Login';
import {count} from './Login'
import { useStateValue } from './State';

// const check=()=>{ if(count==0)
//     {
//       return false;
//     }
//   }
function App() {
  // const auth=check();
  
   const [{isLoggedIn},dispatch]=useStateValue();
   console.log(isLoggedIn);
   if(isLoggedIn===false)
   <Router>
     <Login/>
    </Router>
  return (
    <Router>
            {/* { auth ?  : <Navigate to="/login" />}; */}
            
                
    <div className="App">
       <Routes>
          <Route path="/login" element={<Login/>}/>
          
           <Route path="/" element={[<Navbar/> , <Home/>]}   />
          
          
           
          <Route path="/cart" element={[<Navbar/>,<Cart/>]}   />
            
          
         
       </Routes>
      </div>
    </Router>
      
  );
}

export default App;
